var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: 7,
    fill: "none",
    stroke: "currentColor"
  })));
}
export default SvgLoader;